// exclude-from-index
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { PortalSVGIcon, SVGIcon } from '@custom-components';
import { withTheme } from 'styled-components';
import { themePropType } from '@themes';
import LinkList from '../../common/LinkList';

import {
  StyledExpansionPanel,
  StyledExpansionPanelSummary,
  StyledExpansionPanelDetails,
  StyledNav,
  StyledNavLink,
  HelpSupport,
  RouteRect
} from './SubMenuExpanded.styles';

export const linkPropType = PropTypes.shape({
  id: PropTypes.string,
  href: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  target: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.string,
  routeMatches: PropTypes.arrayOf(PropTypes.string)
});

export const subLinkPropType = PropTypes.shape({
  id: PropTypes.string,
  href: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  target: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.string,
  routeMatches: PropTypes.arrayOf(PropTypes.string),
  subMenu: PropTypes.arrayOf(linkPropType)
});

class SubMenuExpanded extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: ''
    };
  }

  handleChange = (panel) => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false
    });
  };

  renderMenu() {
    const { subMenuLinks } = this.props;

    const links = subMenuLinks.map((link) => this.renderLink(link));

    return links;
  }

  renderLink = (link) => {
    const { routeName, onItemClick, theme } = this.props;
    const { expanded } = this.state;
    const { onClick, href, target, label, icon, subMenu, routeMatches, id } = link;
    const lightTheme = theme ? theme.lightTheme : 'white';
    const lightText = theme ? theme.lightText : 'white';

    const interceptedOnClick =
      onClick && typeof onClick === 'function'
        ? (e) => {
            onClick(e, onItemClick);
          }
        : onItemClick;

    if (subMenu.length === 0) {
      return (
        <StyledNavLink
          key={id}
          href={href || '#'}
          onClick={interceptedOnClick}
          target={target || null}
          title={label}
          className={routeMatches.includes(routeName) ? 'curRoute' : ''}
        >
          {routeMatches.includes(routeName) && icon && <RouteRect />}
          {icon && (
            <PortalSVGIcon
              selectedIcon={icon}
              width="24px"
              height="24px"
              iconColor={routeMatches.includes(routeName) ? lightTheme : lightText}
            />
          )}
          <div className="label">{label}</div>
        </StyledNavLink>
      );
    }

    const sublinks = subMenu.map((sublink) => this.renderLink(sublink));

    return (
      <StyledExpansionPanel
        key={id}
        expanded={expanded === id}
        onChange={this.handleChange(id)}
        className={subMenu.find((sublink) => sublink.routeMatches.includes(routeName)) ? 'curRoute' : ''}
      >
        <StyledExpansionPanelSummary
          className={subMenu.find((sublink) => sublink.routeMatches.includes(routeName)) ? 'curRoute' : ''}
          expandIcon={
            <SVGIcon
              selectedIcon="arrow"
              iconColor={subMenu.find((sublink) => sublink.routeMatches.includes(routeName)) ? lightTheme : lightText}
            />
          }
          title={label}
        >
          <StyledNav>
            {subMenu.find((sublink) => sublink.routeMatches.includes(routeName)) && <RouteRect />}
            <PortalSVGIcon
              selectedIcon={icon}
              width="24px"
              height="24px"
              iconColor={subMenu.find((sublink) => sublink.routeMatches.includes(routeName)) ? lightTheme : lightText}
            />
            <div className="label">{label}</div>
          </StyledNav>
        </StyledExpansionPanelSummary>
        <StyledExpansionPanelDetails>
          <LinkList links={sublinks} />
        </StyledExpansionPanelDetails>
      </StyledExpansionPanel>
    );
  };

  render() {
    // const { routeName, onItemClick, theme, helpSupport } = this.props;
    // const { href, target, label, routeMatches, onClick } = helpSupport;

    // const interceptedOnClick =
    //   onClick && typeof onClick === 'function'
    //     ? e => {
    //         onClick(e, onItemClick);
    //       }
    //     : onItemClick;
    // const lightTheme = theme ? theme.lightTheme : 'white';
    // const lightText = theme ? theme.lightText : 'white';

    return (
      <>
        {this.renderMenu()}
        <HelpSupport />
        {/* No help and support pages r1 */}
        {/* <HelpSupport>
          <StyledNavLink
            href={href || '#'}
            onClick={interceptedOnClick}
            target={target || null}
            title={label}
            className={routeMatches.includes(routeName) ? 'curRoute' : ''}
          >
            {routeName === 'HelpAndSupport' && <RouteRect />}
            <PortalSVGIcon
              selectedIcon="help"
              width="24px"
              height="24px"
              iconColor={routeName === 'HelpAndSupport' ? lightTheme : lightText}
            />
            <div className="label">Help & Support</div>
          </StyledNavLink>
        </HelpSupport> */}
      </>
    );
  }
}

SubMenuExpanded.propTypes = {
  /**
   * An array of link objects passed through.
   */
  subMenuLinks: PropTypes.arrayOf(subLinkPropType),

  /** name of current route */
  routeName: PropTypes.string,

  /** function when a menu item is clicked */
  onItemClick: PropTypes.func,

  /**
   * Passed Component of the link that takes a user to the support page.
   */
  helpSupport: linkPropType,

  theme: themePropType
};

SubMenuExpanded.defaultProps = {
  subMenuLinks: [],
  routeName: '',
  onItemClick: () => {},
  helpSupport: null,
  theme: {}
};

const ComposedSubMenuExpanded = withTheme(SubMenuExpanded);
export default ComposedSubMenuExpanded;
